import { PDFDocument } from 'pdf-lib';
import logger from 'utils/logger';

const log = logger.createLogger('PreviewUtils');

export const isPDF = async (presignedUrl) => {
  try {
    const response = await fetch(presignedUrl, {
      method: 'GET',
      headers: {
        Range: 'bytes=0-4',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const headerBytes = await response.arrayBuffer();
    const arr = new Uint8Array(headerBytes).subarray(0, 5);
    let header = '';
    for (let i = 0; i < arr.length; i++) {
      header += String.fromCharCode(arr[i]);
    }

    // Check if the header matches the PDF magic number
    return header === '%PDF-';
  } catch (error) {
    log.error('Error fetching file header:', error);
    return false;
  }
};

export const loadPdfFromPresignedURL = async (presignedUrl) => {
  const existingPdfBytes = await fetch(presignedUrl).then((res) =>
    res.arrayBuffer()
  );
  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  return url;
};
